import { isFetchCollectionResultSuccessful } from '../../entities/FetchResult'
import { getPayrollPeriodsApiCall } from '../../entities/PayrollPeriod/PayrollPeriodService'
import { TypedDispatch } from '../store'
import { setError, setIsLoading, setPayrollPeriods } from './payrollPeriodsReducer'

export const getPacoPayrollPeriods = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    try {
        const response = await getPayrollPeriodsApiCall()

        if (! isFetchCollectionResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        dispatch(setPayrollPeriods(response.data))
    } catch (error) {
        console.error('[fetchPayrollPeriods]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
